import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/PuiPi-Market/client/src/app/[lang]/ClientProviders.js");
